import React from 'react'
import { Box, Grid, Button, Typography, Divider } from '@mui/material';
import Instagram from '@mui/icons-material/Instagram';
import Web from '@mui/icons-material/Web';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import YouTubeIcon from '@mui/icons-material/YouTube';

import Logo_01 from '../../data/images/ysLogo1.png'
import logoImg from '../../data/images/footerLogo.png';
import img01 from '../../data/mainImg/image_09.jpg';
import img02 from '../../data/mainImg/image_10.jpg';
import img03 from '../../data/mainImg/image_11.jpg';

type Props = {}

const webWidth = window.innerWidth;

const Footer = (props: Props) => {
    return (
        <>
        {/* <Grid container
            sx={{
                backgroundColor: '#f0f0f0', 
                width: '100%', 
                height: '600px',
            }}
        >
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center', padding: 2}}>
                <img src={Logo_01} width={'100px'}/>
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center', padding: 1}}>
                <Typography sx={{ fontSize: '20px', fontFamily: 'Poppins' }}>곤지암 연세 FC</Typography>
            </Grid>
            
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center', padding: 1}}>
                Link 1 | Link 2 | Link 3 | Link 4 | Link 5
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center', padding: 1}}>
                © Gonjiam Yonsei FC 2023, All rights reserved.
            </Grid>
        </Grid> */}
        <Grid container sx={{
                backgroundColor: '#032547', 
                width: '100%', 
                height: 'auto',
                padding: 10,
                '@media (max-width: 1300px)': {
                    padding: 5,
                }
            }}>
            <Grid item xs={12} lg={3}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography 
                        sx={{
                        fontWeight: 600,
                        fontSize: '1.5em',
                        fontFamily: 'Roboto',
                        color: 'white',
                        letterSpacing: -1
                        }}
                        >About Yonsei</Typography>
                        {
                            webWidth > 1300
                            ?
                            <img src={logoImg} width={'200px'} style={{ marginTop: '1.5em' }}/>
                            :
                            <img src={logoImg} width={'100px'} style={{ marginTop: '1.5em' }}/>
                        }
                        <Typography fontSize={'1.2em'} mt={3} fontWeight={600} color={'white'}>곤지암 연세 FC</Typography>
                        <Typography mt={1} color={'white'}>📞 031-764-2579</Typography>
                        <Typography mt={1} color={'white'}>⚽ 경기 광주시 초월읍 경충대로 860</Typography>
                        {/* <Typography>개인정보처리약관</Typography> */}
                </Box>
            </Grid>
            <Grid item xs={12} lg={2.5}>
                <Box sx={{ display: 'flex', flexDirection: 'column', '@media (max-width: 1300px)': { display: 'none' } }}>
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: '1.5em',
                            fontFamily: 'Roboto',
                            color: 'white',
                            letterSpacing: -1
                            }}
                        >Partners</Typography>
                        <Box mt={4} color={'white'}>
                            <Typography p={1}>험멜</Typography>
                            <Typography p={1}>펄스나인</Typography>
                            <Typography p={1}>Sklz</Typography>
                            <Typography p={1}>아미노 더 라이프</Typography>
                            <Typography p={1}>수원 센텀 병원</Typography>
                        </Box>
                </Box>
            </Grid>
                <Grid item xs={12} lg={2.5} sx={{ '@media (max-width: 1300px)': { display: 'none' } }}>
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: '1.5em',
                            fontFamily: 'Roboto',
                            color: 'white',
                            letterSpacing: -1,
                            flexDirection: 'column',
                            }}
                        >Social Media</Typography>
                        <Box mt={3}>
                            <Button sx={{ color: '#308cff' }}>
                                <Instagram />
                            </Button>
                            <Button sx={{ color: '#308cff' }}>
                                <Web />
                            </Button>
                            <Button sx={{ color: '#308cff' }}>
                                <YouTubeIcon />
                            </Button>
                        </Box>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: '1.5em',
                                fontFamily: 'Roboto',
                                color: 'white',
                                letterSpacing: -1,
                                flexDirection: 'column',
                                mt: 5
                                }}
                            >CS Center</Typography>
                        <Box mt={3}>
                            <Button sx={{ color: '#308cff' }}>상담 게시판</Button>
                            <Button sx={{ color: '#308cff' }}>이메일 상담</Button>
                            <Button sx={{ color: '#308cff' }}>챗봇 상담</Button>
                        </Box>
                </Grid>
                <Grid item xs={12} lg={4}>
                <Box sx={{ '@media (max-width: 1300px)': { display: 'none' } }}>
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: '1.5em',
                            fontFamily: 'Roboto',
                            color: 'white',
                            letterSpacing: -1
                            }}
                        >Instagram</Typography>
                    <Grid container sx={{ mt: 3 }}>
                        <Grid item xs={6} lg={4} sx={{ borderRadius: '15px' }}>
                            <img src={img01} width={200} height={200} />
                        </Grid>
                        <Grid item xs={6} lg={4} sx={{ borderRadius: '15px' }}>
                            <img src={img02} width={200} height={200} />
                        </Grid>
                        <Grid item xs={12} lg={4} sx={{ borderRadius: '15px' }}>
                            <img src={img03} width={200} height={200} />
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
            <Grid item xs={12} lg={12} mt={5}>
                <Divider color={'white'} />
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center', mt: 3, fontSize: '0.9em', color: 'white' }}>
                © Gonjiam Yonsei FC 2023, All rights reserved.
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ display: 'flex', justifyContent: 'center', mt: 1, fontSize: '0.8em', color: 'white' }}>
                Web Developed by DevNew
            </Grid>
        </Grid>
        </>
    )
}

export default Footer